function addZero(value) {
  return value < 10 ? `0${value}` : value;
}

/**
 * 解析富文本编辑器返回的html代码
 */
export const resolveHtml = {
  dom: document.createElement('div'),
  decode(str) {
    let s = '';

    if (typeof str !== 'string' || str.length === 0) {
      return;
    }
    s = str.replace(/&amp;/g, '&');
    s = s.replace(/&lt;/g, '<');
    s = s.replace(/&gt;/g, '>');
    // s = s.replace(/&nbsp;/g, " /g);
    s = s.replace(/&#39;/g, "'");
    s = s.replace(/&quot;/g, '"');
    return s;
  },
  encode(str) {
    if (!str) {
      return '';
    }
    this.dom.innerHTML = str;
    return this.dom.innerText;
  },
};

/**
 * [isMobile 判断平台]
 * @param test:	0:iPhone	1:Android
 */
export const ismobile = (test) => {
  const u = navigator.userAgent;
  if (
    /AppleWebKit.*Mobile/i.test(navigator.userAgent) ||
    /MIDP|SymbianOS|NOKIA|SAMSUNG|LG|NEC|TCL|Alcatel|BIRD|DBTEL|Dopod|PHILIPS|HAIER|LENOVO|MOT-|Nokia|SonyEricsson|SIE-|Amoi|ZTE/.test(
      navigator.userAgent,
    )
  ) {
    if (window.location.href.indexOf('?mobile') < 0) {
      try {
        if (/iPhone|mac|iPod|iPad/i.test(navigator.userAgent)) {
          return '0';
        }
        return '1';
      } catch (e) {}
    }
  } else if (u.indexOf('iPad') > -1) {
    return '0';
  } else {
    return '1';
  }
};
export const getUrlParam = (name, search) => {
  search = search || window.location.search.substr(1) || window.location.hash.split('?')[1] || '';
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
  const r = search.match(reg);
  if (r != null) return unescape(r[2]);
  return null;
};
export const getQueryString = (name) => {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`); // 构造一个含有目标参数的正则表达式对象
  const r = window.location.search.substr(1).match(reg); // 匹配目标参数
  if (r != null) return decodeURI(r[2]);
  return null; // 返回参数值
};

export const praseStrEmpty = (str) => {
  if (!str || str === 'undefined' || str === undefined || str === 'null' || str === null) {
    return '';
  }
  return str;
};

export const formatSeconds = (value) => {
  let theTime = parseInt(value); // 秒
  let middle = 0; // 分
  let hour = 0; // 小时

  if (theTime > 60) {
    middle = parseInt(theTime / 60);
    theTime = parseInt(theTime % 60);
    if (middle > 60) {
      hour = parseInt(middle / 60);
      middle = parseInt(middle % 60);
    }
  }
  let result = `${addZero(parseInt(theTime))}`;
  if (middle > 0) {
    result = `${addZero(parseInt(middle))}:${result}`;
  }
  if (hour > 0) {
    result = `${addZero(parseInt(hour))}:${result}`;
  }
  return result;
};

export const dateFormat = (fmt, time) => {
  const date = new Date(time);
  let ret;
  const opt = {
    'Y+': date.getFullYear().toString(), // 年
    'm+': (date.getMonth() + 1).toString(), // 月
    'd+': date.getDate().toString(), // 日
    'H+': date.getHours().toString(), // 时
    'M+': date.getMinutes().toString(), // 分
    'S+': date.getSeconds().toString(), // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (const k in opt) {
    ret = new RegExp(`(${k})`).exec(fmt);
    if (ret) {
      fmt = fmt.replace(ret[1], ret[1].length === 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'));
    }
  }
  return fmt;
};

export const isEmpty = (v) => {
  switch (typeof v) {
    case 'undefined':
      return true;
    case 'string':
      if (v.replace(/(^[ \t\n\r]*)|([ \t\n\r]*$)/g, '').length === 0) return true;
      break;
    case 'boolean':
      if (!v) return true;
      break;
    case 'number':
      if (0 === v || isNaN(v)) return true;
      break;
    case 'object':
      if (null === v || v.length === 0) return true;
      for (const i in v) {
        return false;
      }
      return true;
  }
  return false;
};

// 防抖
export const debounce = (func, delay) => {
  let timer;
  return function (...args) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      func.apply(this, args);
      clearTimeout(timer);
    }, delay);
  };
};

// 删除指定url
export const urlDelP = (name, url) => {
  url = url || window.location.href;
  var urlArr = url.split('?');
  if (urlArr.length > 1 && urlArr[1].indexOf(name) > -1) {
    var query = urlArr[1];
    var obj = {};
    var arr = query.split('&');
    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].split('=');
      obj[arr[i][0]] = arr[i][1];
    }
    delete obj[name];
    const key = Object.keys(obj);
    if (key.length === 0) return urlArr[0];
    var urlte =
      urlArr[0] +
      '?' +
      JSON.stringify(obj)
        .replace(/[\"\{\}]/g, '')
        .replace(/\:/g, '=')
        .replace(/\,/g, '&');
    return urlte;
  } else {
    return url;
  }
};

/**
 * @description 超出字符数量则显示...
 * @export truncateString
 * @param {string} str
 * @param {number} [num=10]
 * @returns {string}
 */
export const truncateString = (str = '', num = 10) => {
  if (str.length <= num) {
    return str;
  }
  return str.slice(0, num) + '...';
};
